
export default {
  code: "fi",
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  },
  buttonText: {
    prev: "Edellinen",
    next: "Seuraava",
    today: "Tänään",
    month: "Kuukausi",
    week: "Viikko",
    day: "Päivä",
    list: "Tapahtumat"
  },
  weekLabel: "Vk",
  allDayText: "Koko päivä",
  eventLimitText: "lisää",
  noEventsMessage: "Ei näytettäviä tapahtumia"
};
